import { Col, List, Row } from "antd";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./template.module.css";
import { SubmitButton, TextComponent } from "../../../../components";

import img1 from "../../../../assets/staticImages/templates/template1.png";
import img2 from "../../../../assets/staticImages/templates/template2.png";
import img3 from "../../../../assets/staticImages/templateImg.png";
import { memo } from "react";

const similarTemplates = [
  {
    title: "Artistic",
    img: img1,
  },
  {
    title: "Elegant",
    img: img2,
  },
];

const RenderItem = memo(({ item }) => {
  return (
    <>
      <img className={styles.imageSim} src={item.img} alt="example" />
      <TextComponent textClass={styles.textClass} text={item.title} />
    </>
  );
});

function Template() {
  const {
    state: { data: templateData },
  } = useLocation();

  const navigation = useNavigate();
  return (
    <>
      <Row className={styles.container}>
        <Col className={styles.imgContainer}>
          <img
            src={templateData?.image}
            className={styles.image}
            alt="template img"
          />
        </Col>
        <Col className={styles.leftContainer}>
          <TextComponent
            text={templateData.title}
            textClass={styles.textHead}
          />
          <TextComponent
            text={"Customize template with your custom wish!"}
            textClass={styles.text}
          />
          <SubmitButton
            title="Customize This Template"
            btnClass={styles.btn}
            onClick={() =>
              navigation("/templates/CustomizeTemplate", {
                state: { templateData },
              })
            }
          />

          {/* <TextComponent text='Similar Templates' textClass={styles.textSim} />
                <List
                    className={styles.listClass}
                    grid={{
                        xs: 1,
                        sm: 2,
                        md: 2,
                        lg: 2,
                        xl: 2,
                        xxl: 2,
                    }}
                    dataSource={similarTemplates}
                    renderItem={(item) => <RenderItem item={item} />}
                /> */}
        </Col>
      </Row>
    </>
  );
}

export default Template;
